import {
  Entity,
  Column,
  PrimaryGeneratedColumn,
  ManyToOne,
  JoinColumn,
  CreateDateColumn,
  UpdateDateColumn,
} from 'typeorm';

import { Brand } from '../../utils/enums.utils';
import { LeadStatus } from '../../interface/leads/leads-response.interface';

import { UsersEntity } from '../users/user.entity';
import { ClientsEntity } from '../clients/clients.entity';

@Entity('leads')
export class LeadsEntity {
  @PrimaryGeneratedColumn('uuid')
  id!: string;

  @Column({ type: 'varchar' })
  brand!: Brand;

  @Column({ type: 'text', nullable: true })
  description?: string | null;

  @Column({
    type: 'decimal',
    precision: 15,
    scale: 2,
    nullable: true,
  })
  estimated_amount?: number | null;

  @Column({ type: 'date', nullable: true })
  target_date?: Date | null;

  @Column({ type: 'varchar' })
  status!: LeadStatus;

  @Column({ type: 'text', nullable: true })
  remarks?: string | null;

  @Column({ type: 'text', nullable: true })
  brand_description?: string | null;

  @CreateDateColumn()
  created_at!: Date;

  @UpdateDateColumn()
  updated_at!: Date;

  @ManyToOne(() => UsersEntity, { nullable: false })
  @JoinColumn({ name: 'created_by_id' })
  created_by?: UsersEntity | null;

  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'updated_by_id' })
  updated_by?: UsersEntity | null;

  @ManyToOne(() => ClientsEntity, { nullable: false })
  @JoinColumn({ name: 'client_id' })
  client?: ClientsEntity;
}